module.exports = __webpack_public_path__ + "bcd10cd087a563b9a3c83ca25c53891b.pdf";